import React, { useState, useEffect, Suspense, lazy } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer";
import Particle from "./components/Particle";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import "./style.css";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";

// Split heavier pages (Resume pulls in the PDF viewer) out of the main bundle
// so phones only download them when visited.
const About = lazy(() => import("./components/About/About"));
const Projects = lazy(() => import("./components/About/Projects"));
const Resume = lazy(() => import("./components/Resume/ResumeNew"));

function App() {
  const [load, upadateLoad] = useState(true);

  useEffect(() => {
    // Hide the preloader once the page has loaded, rather than after a fixed delay.
    const done = () => upadateLoad(false);
    const minDelay = setTimeout(() => {
      if (document.readyState === "complete") done();
      else window.addEventListener("load", done, { once: true });
    }, 300);
    const maxDelay = setTimeout(done, 1200);

    return () => {
      clearTimeout(minDelay);
      clearTimeout(maxDelay);
      window.removeEventListener("load", done);
    };
  }, []);

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll" }>
        <Particle />

        <Navbar />

        <ScrollToTop />
        <Suspense fallback={<div className="route-loading" />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/project" element={<Projects />} />
            <Route path="/about" element={<About />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="*" element={<Navigate to="/"/>} />
          </Routes>
        </Suspense>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
